import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {
  SupplyChains,
  SingleSupplyChain,
  ProjectSupplyChain,
  UpdateProjectSearchTags,
  ProjectSupplyChainResponse,
  ITimerUpdate,
  ILicence,
  IUpdateProject,
} from '@/store/models';
import {
  fetchAllSupplyChains,
  fetchRegisteredSupplyChains,
  fetchMySupplyChains,
  fetchProjectWithForm,
  fetchSingleSupplyChain,
  fetchProjectSupplyChain,
  getProject,
  updateTimer,
  fetchSingleProject,
  getProjectCategories,
  fetchSupplyChainsByOrg,
  deleteAttachment,
} from '@/store/api';
import { createMultipleAttachments,createProject,
  updateProject, } from '@/store/attachment';

@Module({
  namespaced: true,
  name: 'supplyChains',
  store,
  dynamic: true,
})
class SupplyChainsModule extends VuexModule {
  public supplyChains: SupplyChains | null = null;
  public registeredSupplyChains: SupplyChains | null = null;
  public mySupplyChains: SupplyChains[] | null = [];
  public singleSupplyChain: SingleSupplyChain | null = null;
  public projectSupplyChain: ProjectSupplyChain | null = null;
  public attachments: any | null = null;
  public singleProject: SingleSupplyChain | null = null;
  public orgSupplyChains: SupplyChains[] | null = null;

  get all() {
    return this.supplyChains || null;
  }

  get myOrg() {
    return this.orgSupplyChains || [];
  }

  get registered() {
    return this.registeredSupplyChains || null;
  }

  get my() {
    return this.mySupplyChains || [];
  }

  get single() {
    return this.singleSupplyChain || null;
  }

  get oneProject() {
    return this.singleProject || null;
  }

  get project() {
    return this.projectSupplyChain || null;
  }

  get searchTags() {
    return (this.projectSupplyChain && this.projectSupplyChain.buyer_tags) || [];
  }

  @Action
  public async deleteSingleAttachment(payload: any) {
    await deleteAttachment(payload);
  }

  @MutationAction
  public async loadRegisteredSupplyChains() {
    const registeredSupplyChains = await fetchRegisteredSupplyChains();
    return { registeredSupplyChains };
  }

  @MutationAction
  public async loadMySupplyChains() {
    const mySupplyChains = await fetchMySupplyChains();
    return { mySupplyChains };
  }

  @Action
  public async loadAllSupplyChains() {
    return await fetchAllSupplyChains();
  }

  @MutationAction
  public async loadSupplyChainsByOrg(orgId: number | string) {
    const orgSupplyChains = await fetchSupplyChainsByOrg(orgId);
    return { orgSupplyChains };
  }

  @MutationAction
  public async loadSingleSupplyChain(pid: string | number) {
    const singleSupplyChain = await fetchSingleSupplyChain(pid);
    return { singleSupplyChain };
  }

  @MutationAction
  public async loadSingleProject(pid: string | number) {
    const singleProject = await fetchSingleProject(pid);
    return { singleProject };
  }

  @MutationAction
  public async loadProjectSupplyChain(pid: string | number) {
    const projectSupplyChain = await fetchProjectSupplyChain(pid);
    return { projectSupplyChain };
  }

  @MutationAction
  public async getProjectRegisterForm(pid: string) {
    const singleSupplyChain = await fetchProjectWithForm(pid);
    return { singleSupplyChain };
  }

  @Action
  public async updateSearchTags(project: SupplyChains) {
    const projectSupplyChain = await updateProject(project);
    return { projectSupplyChain };
  }

  @Action
  public async createProject(project: SupplyChains) {
    return await createProject(project);
  }

  @Action
  public async updateProject(project: SupplyChains | IUpdateProject) {
    const singleSupplyChain = await updateProject(project);
    return { singleSupplyChain };
  }

  @MutationAction
  public async createAttachments(payload: any) {
    const attachments = await createMultipleAttachments(payload);
    return { attachments };
  }

  @MutationAction
  public async getSearchTags(project: any) {
    const singleSupplyChain = await getProject(project);
    return { singleSupplyChain };
  }

  @Action
  public async timer(timerData: ITimerUpdate) {
    return await updateTimer(timerData);
  }

  @Action
  public async fetchProjectCategories(project_id: number | string) {
    return await getProjectCategories(project_id);
  }
}

export default getModule(SupplyChainsModule);
